import * as React from 'react';
import { BadgeSize, BadgeType } from '../Badge';
import { PopoverCommonProps } from '../common';
import { BadgeSelectItemProps } from '../BadgeSelectItem';

export interface BadgeSelectProps {
  options: BadgeSelectItemProps[];
  selectedId?: string;
  onSelect?: (option: BadgeSelectItemProps) => void;
  size?: BadgeSize;
  type?: BadgeType;
  uppercase?: boolean;
  dataHook?: string;
  popoverProps?: PopoverCommonProps;
}

export default class BadgeSelect extends React.Component<BadgeSelectProps> {
  hideDropdown: () => void;
  showDropdown: () => void;
  toggleDropdown: () => void;
  getSelectedOption: (props: any) => BadgeSelectItemProps;
}

export { BadgeSelectItemProps };
